export const RELAUNCH_PREVIEW_DISCLAIMERS = [
    "This relaunch preview is a draft proposal only — it does not activate BusinessGraph truth or change live project data.",
    "Agency and client confirmation is required before any proposed relaunch becomes active.",
    "This preview does not guarantee search rankings, compliance, or launch readiness.",
    "Automated scan signals may be incomplete; verify findings before client delivery.",
];
export const RELAUNCH_PREVIEW_DRAFT_PROPOSAL_NOTE = "Draft BusinessGraph proposal generated from public scan signals. Review and edit before activation — this is not active project truth.";
export const PROOF_RELAUNCH_TEMPLATE_HEADLINE = "Proof Relaunch pilot template";
export const PROOF_RELAUNCH_TEMPLATE_SUBCOPY = "Safe pilot path for one proof relaunch — draft-only import from claimed scan opportunity.";
export const BATCH_AUDIT_DISCLAIMERS = [
    "Batch audit results are agency-scoped opportunity signals — not client-facing guarantees.",
    "Ranking and labels are heuristic only; agency review is required before outreach.",
    "Blocked URLs were rejected by SSRF safety policy and were not scanned.",
];
export const BATCH_AUDIT_OPPORTUNITY_LABEL_DISPLAY = {
    QUICK_FIX: {
        label: "Quick Fix",
        detail: "Minor readiness gaps — likely addressable with targeted fixes.",
    },
    FIX_KIT_CANDIDATE: {
        label: "Fix Kit Candidate",
        detail: "Moderate issues suitable for a Fix Kit pilot engagement.",
    },
    RELAUNCH_CANDIDATE: {
        label: "Relaunch Candidate",
        detail: "Multiple structural gaps suggest a broader relaunch conversation.",
    },
    PROOF_RELAUNCH_CANDIDATE: {
        label: "Proof Relaunch Candidate",
        detail: "Low score or many failures — strong candidate for proof relaunch pilot.",
    },
    OWNERSHIP_GAP: {
        label: "Ownership Gap",
        detail: "Signals suggest access, trust, or ownership handoff gaps.",
    },
    LEAD_PATH_WEAK: {
        label: "Lead Path Weak",
        detail: "Contact or lead path signals are weak or missing.",
    },
};
//# sourceMappingURL=relaunch-preview-copy.js.map